import { useMemo, useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { hotPicks } from '@/mocks/library';

const filters = ['全部', '电影', '剧集', '动漫', '综艺', '纪实'];

export default function HotPicks() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? hotPicks : hotPicks.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section id="hot" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeading
          eyebrow="热门新片"
          title="热门新片精选"
          description="近期上新与讨论度较高的作品集中在这里，切换标签即可按类型筛选，卡片保留评分、地区与看点提示。"
        />
        <div
          className="flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200 self-start lg:self-auto"
          role="tablist"
          aria-label="按类型筛选热门新片"
        >
          {filters.map((item) => {
            const isActive = item === active;
            return (
              <button
                key={item}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(item)}
                className={`px-3 md:px-4 py-1.5 text-xs md:text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-primary-100 hover:text-primary-800'
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
        {list.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full aspect-[2/3] bg-background-200 overflow-hidden">
              <img
                src={item.poster}
                alt={`${item.title} 封面海报`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-foreground-950/70 text-accent-300 text-xs font-bold">
                <i className="ri-star-fill w-3 h-3 flex items-center justify-center" aria-hidden="true"></i>
                {item.score}
              </span>
              <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 text-[11px] font-medium text-foreground-900">
                {item.category}
              </span>
            </div>
            <div className="flex flex-col flex-1 p-4 md:p-5">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">
                {item.year} · {item.region}
              </p>
              <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-700 flex-1">{item.blurb}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span key={tag} className="text-[11px] px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>

      {list.length === 0 ? (
        <p className="mt-8 text-center text-sm text-foreground-600">
          该类型暂时没有条目，先看看其他分类吧。
        </p>
      ) : null}
    </section>
  );
}